const initialState = {
    username: null,
    tokenJWT: null
}

const userReducer = (state = initialState, action) => {

    switch (action.type) {
        case 'USER_SAVE':
            return {
                ...state,
                username: action.data.username,
                tokenJWT: action.data.tokenJWT
            }
        case 'USER_DELETE':
            return {
                ...state,
                tokenJWT: null,
            }
        default:
            return state
    }

}

export default userReducer
